import React, { Component } from 'react';

import { t } from '../i18n';

// Message de chargement qui compte les secondes : après 6 s, on prévient que le serveur est lent
// (au lieu de laisser croire que la liste est vide). Journalise aussi la durée dans la console.
export default class LoadingHint extends Component {

  state = { seconds: 0 };

  componentDidMount() {
    this.started = Date.now();
    this.timer = setInterval(() => this.setState({ seconds: Math.round((Date.now() - this.started) / 1000) }), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    console.log(`[tsk] liste chargée en ${((Date.now() - this.started) / 1000).toFixed(1)} s`);
  }

  render() {
    const { seconds } = this.state;
    return (
      <p className='tsk-loading-hint' role='status'>
        {seconds >= 6 ? t('ui.loading.slow', { seconds }) : t('ui.common.loading')}
      </p>
    );
  }
}
